import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './input.scss';

const Input = ({
  children,
  className,
  errorMsg,
  id,
  invalid,
  label,
  onBlur,
  onChange,
  onClick,
  placeholder,
  readOnly,
  type,
  value,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleBlur = (evt) => {
    setIsFocused(false);
    onBlur(evt);
  };

  return (
    <div className={`input ${invalid ? 'input_error' : ''} ${className}`}>
      {label && (
        <label
          htmlFor={id}
          className={`input__label ${
            isFocused || value?.length ? 'input__label_raised' : ''
          }`}
        >
          {label}
        </label>
      )}
      <input
        id={id}
        className="input__field"
        onChange={onChange}
        onClick={onClick}
        onBlur={handleBlur}
        onFocus={() => setIsFocused(true)}
        placeholder={placeholder}
        readOnly={readOnly}
        type={type}
        value={value}
      />
      {children}
      {invalid && errorMsg && (
        <div className="input__error-msg">{errorMsg}</div>
      )}
    </div>
  );
};

Input.defaultProps = {
  className: '',
  errorMsg: '',
  invalid: false,
  label: '',
  onBlur: () => {},
  onChange: () => {},
  onClick: () => {},
  placeholder: '',
  readOnly: false,
  type: 'text',
  value: '',
};

Input.propTypes = {
  className: PropTypes.string,
  errorMsg: PropTypes.string,
  id: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string,
};

export default Input;
